import getConfig from './environments.js';

export const getAuthConfig = () => {
  const config = getConfig();
  return {
    authority: config.fusionAuth.url,
    client_id: config.fusionAuth.clientId,
    redirect_uri: `${config.fusionAuth.redirectUri}/auth/callback`,
    post_logout_redirect_uri: config.fusionAuth.redirectUri,
    scope: 'openid profile email offline_access',
    response_type: 'code',
    loadUserInfo: true,
    // Renewal is driven by authfusion.js (refresh-token grant on accessTokenExpiring);
    // oidc-client's own iframe renew would race it and cannot work for password sessions.
    automaticSilentRenew: false,
    silent_redirect_uri: `${config.fusionAuth.redirectUri}/auth/silent-renew`,
    monitorSession: false,
    checkSessionInterval: 60000,
    metadata: {
      issuer: config.fusionAuth.issuer,
      authorization_endpoint: `${config.fusionAuth.url}/oauth2/authorize`,
      token_endpoint: `${config.fusionAuth.url}/oauth2/token`,
      userinfo_endpoint: `${config.fusionAuth.url}/oauth2/userinfo`,
      end_session_endpoint: `${config.fusionAuth.url}/oauth2/logout`,
      jwks_uri: `${config.fusionAuth.url}/.well-known/jwks.json`,
    },
  };
};
